import { cva } from "class-variance-authority";
// -----------------------------------------------------------------------------

export default {
  group: {
    root: cva("flex flex-col space-y-2", {
      variants: {
        hasBorder: {
          true: "border-control-default border-t pt-4"
        }
      }
    }),
    label: cva("text-base-500 w-full text-xs font-medium"),
    item: cva("")
  },
  layout: {
    root: cva("flex w-full", {
      variants: {
        isHorizontal: {
          true: "flex-col space-y-4 md:flex-row md:flex-wrap md:space-y-0 md:space-x-4",
          false: "flex-col space-y-4"
        }
      }
    }),
    item: cva("w-full empty:hidden data-[visible='false']:hidden", {
      variants: {
        isHorizontal: {
          true: "md:flex-1",
          false: ""
        }
      }
    })
  }
};
